import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { WEIGHT_BOLD } from "@hl/base-components/lib/theme/typography";
import { SeriesToken } from "@hl/shared-features/lib/apollo/graphql.generated";
import { Title, Text, Box, createStyles, Group } from "@mantine/core";
import { Link } from "react-router-dom";

import TokenOwnedBy from "~features/MintPage/TokenOwnedBy";
import useMintState from "~hooks/useMintState";

import { getMintPageUrl } from "../../config";
import CollectionCreatedBy from "../MintPage/CollectionCreatedBy";

const useStyles = createStyles({
  link: {
    textDecoration: "none",
  },
});

const TokenDetailsTitleSection = ({ token }: { token: SeriesToken }) => {
  const { collection } = useMintState();
  const { classes } = useStyles();

  if (!collection) return null;

  return (
    <Box>
      <Link className={classes.link} to={getMintPageUrl(collection)}>
        <Text size="sm" color={TEXT_COLOR.TERTIARY} tt="uppercase">
          {collection.name}
        </Text>
      </Link>
      <Title order={4} fw={WEIGHT_BOLD} mt={6} lineClamp={2} display="block">
        {token.name.match(/^(#?\d+)$/)
          ? `${collection.name} ${token.name}`
          : `${token.name}`}
      </Title>
      <Group mt={10} sx={{ columnGap: 10, rowGap: 4 }} align="center">
        <CollectionCreatedBy />
        <TokenOwnedBy
          ownerAddress={token.ownerAddress ?? undefined}
          ownerEns={token.ownerEns ?? undefined}
          standard={collection.standard ?? undefined}
        />
      </Group>
    </Box>
  );
};

export default TokenDetailsTitleSection;
